import { render, staticRenderFns } from "./goodScore.vue?vue&type=template&id=77fd8546&scoped=true"
import script from "./goodScore.vue?vue&type=script&lang=js"
export * from "./goodScore.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=77fd8546&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fd8546",
  null
  
)

export default component.exports